import { getToken, setToken } from "./api";

export const SESSION_KEY = "wecrew_session";

export function hasSession() {
  return Boolean(localStorage.getItem(SESSION_KEY) || getToken());
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
  setToken(null);
}
